@if(open){
<div
  class="z-50 filter bg-black/30 backdrop-blur-[1px] dark:backdrop-blur-[3px] h-screen w-screen fixed top-0 left-0 flex transition-all">

  <!-- content -->
  <div [class]="
        'modalContent max-h-screen *:transition w-full overflow-x-hidden  flex items-center justify-center py-2' +
        ' ' +
        className
      ">
    <ng-content></ng-content>
  </div>
</div>
}